import React from 'react';
import cn from 'classnames';
import styles from '../sensors.module.scss';
import { ReactComponent as PlusIcon } from '@assets/images/Fireboard/PlusIcon.svg';
import { ReactComponent as DeleteIcon } from '@assets/images/Fireboard/DeleteIcon.svg';
import { ReactComponent as EditPencil } from '@assets/images/Fireboard/editPencil.svg';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';

const TableSensors = props => {
  const {
    filteredWithSensors,
    filteredWithoutSensors,
    sensorsMap,
    onClickAddSensor,
    onClickDeleteSensor,
    onClickEdit,
  } = props;

  const pad = (num, size) => {
    let str = String(num);
    while (str.length < (size || 10)) {
      str = '0' + str;
    }
    return str;
  };

  const sortFunction = (a, b) => {
    const name1 = pad(a.name ? a.name : '', 10).toLowerCase();
    const name2 = pad(b.name ? b.name : '', 10).toLowerCase();
    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }
    return 0;
  };

  const Table = ({ station }) => {
    const { name, number, revenueCenterName } = station || {};
    return (
      <div
        className={cn(
          styles.tableContainer,
          'd-flex flex-column justify-content-center align-items-center'
        )}
        onClick={() => onClickAddSensor(station)}
      >
        <div className={cn('col-12 px-0 text-center')}>
          {name || number}
          {revenueCenterName && (
            <div className={styles.tableNum}>({revenueCenterName})</div>
          )}

          <div className={cn(styles.addIcon, 'col-12 py-2')}>
            <PlusIcon />
          </div>
        </div>
      </div>
    );
  };

  const Sensor = ({ sensor, onClickDeleteSensor }) => {
    const { name, externalId } = sensor || {};

    return (
      <div className={cn(styles.sensorContainer)}>
        <div className="d-flex justify-content-between pb-2">
          <div
            className={cn(styles.sensorName, 'col-9 px-0 pr-2 text-truncate')}
          >
            {name}
          </div>
          <div
            className={cn(
              styles.deleteIcon,
              'mr-2 d-flex justify-content-center align-items-center'
            )}
            onClick={() => onClickEdit(sensor)}
          >
            <EditPencil />
          </div>
          <div
            className={cn(
              styles.deleteIcon,
              'd-flex justify-content-center align-items-center'
            )}
            onClick={() => onClickDeleteSensor(sensor)}
          >
            <DeleteIcon />
          </div>
        </div>
        <span className={styles.external}>{externalId}</span>
      </div>
    );
  };

  const Sensors = ({ sensors }) => {
    return (
      <div className={styles.sensorView}>
        {sensors.map(sensor => (
          <Sensor
            key={`sensorId-${sensor.id}`}
            sensor={sensor}
            onClickDeleteSensor={onClickDeleteSensor}
          />
        ))}
      </div>
    );
  };

  const renderStations = stations => {
    return (
      stations &&
      stations.sort(sortFunction).map(station => {
        const sensors =
          sensorsMap && sensorsMap?.has(station.id)
            ? sensorsMap.get(station.id)
            : [];
        return (
          <div
            key={`stationId-${station.id}`}
            className={cn(styles.stationWrapper, 'col-12 pl-0')}
          >
            <div className="p-3">
              <Table station={station} onClickAddSensor={onClickAddSensor} />
            </div>
            {Array.isArray(sensors) && sensors.length > 0 ? (
              <Sensors sensors={sensors} />
            ) : null}
          </div>
        );
      })
    );
  };

  return (
    <div className="h-82">
      {filteredWithSensors?.length > 0 && filteredWithoutSensors?.length > 0 ? (
        <div className={styles.contentWrapper}>
          {renderStations(filteredWithSensors)}
          {renderStations(filteredWithoutSensors)}
        </div>
      ) : (
        <div
          className={cn(
            styles.noDataWrapper,
            'd-flex justify-content-center align-items-center h-100'
          )}
        >
          {FLABEL().SENSOR_NO_DATA}
        </div>
      )}
    </div>
  );
};

export default TableSensors;
